import { motion } from "framer-motion";
import { Certificate, Stamp, ShieldStar, Medal, Lightning, Gear } from "@phosphor-icons/react";

const certs = [
  { icon: Stamp, title: "Authorised Importer", subtitle: "OEM-grade Indian sourcing", code: "AI-001" },
  { icon: Certificate, title: "ISO 9001:2015", subtitle: "Quality Management System", code: "QM-001" },
  { icon: ShieldStar, title: "IATF 16949", subtitle: "Automotive supply standard", code: "AS-169" },
  { icon: Medal, title: "OEM-Grade Sourcing", subtitle: "Original-equipment specification", code: "OEM-22" },
  { icon: Lightning, title: "Customs Compliant", subtitle: "End-to-end import documentation", code: "CC-008" },
  { icon: Gear, title: "Aftersales Network", subtitle: "Warranty-backed distribution", code: "AS-NET" },
];

export default function Certifications() {
  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="relative py-24 md:py-32 bg-[#B8CCE0] border-y border-[#D5DEE8]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="text-center mb-14">
          <p className="overline-maroon mb-4">03 — Credentials</p>
          <h2 className="font-serif-display font-light text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0F1E33]">
            Standards we <span className="italic text-[#1E3A5F]">stand behind</span>.
          </h2>
          <div className="mx-auto mt-6 w-24 hairline-gold" />
          <p className="mt-6 max-w-2xl mx-auto text-[#4A5A70] text-base md:text-lg leading-relaxed">
            Trust isn't claimed — it's documented. Every framework below is
            independently maintained and applies across our supply chain.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {certs.map((c, idx) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.code}
                data-testid={`cert-card-${idx}`}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: idx * 0.06 }}
                className="group relative bg-white border border-[#D5DEE8] p-8 hover:border-[#B8860B] transition-colors"
              >
                <div className="absolute top-4 right-4 font-mono text-[10px] uppercase tracking-[0.25em] text-[#7B8AA0]">
                  {c.code}
                </div>
                <div className="w-14 h-14 mb-5 flex items-center justify-center border border-[#B8860B]/40 bg-[#C9D9EC] text-[#1E3A5F]">
                  <Icon size={28} weight="duotone" />
                </div>
                <div className="font-serif-display text-2xl text-[#0F1E33]">{c.title}</div>
                <div className="text-sm text-[#4A5A70] mt-2">{c.subtitle}</div>

                <div className="mt-6 flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-[#B8860B]">
                  <span className="w-4 h-px bg-[#B8860B]" />
                  Verified
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
